import { Routes } from '@angular/router';

import { AuthGuard } from '@lib/auth';
import { provideGuaranteesV2Store } from '@lib/guarantees/data-access';
import { clientProfileResolver } from '@lib/members/data-access';
import { clearMemberProfileGuard } from '@lib/members/feature';
import { provideNewTasksCountPolling } from '@lib/tasks';

import { chatRoutes } from '@lib/chat/chat.routes';

import { guaranteesV2EnabledGuard } from '../core/guards/guarantees-v2-enabled.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/access/access-guest/access-guest.component').then(c => c.AccessGuestComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/login/login.component').then(c => c.LoginComponent),
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    loadComponent: () => import('./pages/access/access-authorized/access-authorized.component').then(c => c.AccessAuthorizedComponent),
    canActivate: [AuthGuard],
    providers: [provideNewTasksCountPolling()],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'tasks',
      },
      {
        path: 'members',
        loadComponent: () => import('@lib/members/feature').then(m => m.MembersListComponent),
      },
      {
        path: 'members/:id',
        loadComponent: () => import('./pages/members/member-hub/member-hub.component').then(c => c.MemberHubComponent),
        resolve: { clientData: clientProfileResolver },
        canDeactivate: [clearMemberProfileGuard],
        children: [
          {
            path: 'profile',
            loadComponent: () => import('./pages/members/member-profile/member-profile.component').then(c => c.MemberProfileComponent),
          },
          {
            // Two routes share the path, and the order between them is load-bearing: the v2 surface
            // owns the tab, and the one below is reached only where the flag declines the match.
            path: 'guarantees',
            canMatch: [guaranteesV2EnabledGuard],
            providers: [provideGuaranteesV2Store()],
            loadComponent: () => import('@lib/guarantees/feature').then(m => m.MemberGuaranteesV2Component),
          },
          {
            path: 'guarantees',
            loadComponent: () => import('@lib/members/feature').then(m => m.MemberGuaranteesComponent),
          },
          {
            path: 'appointments',
            loadComponent: () => import('@lib/members/feature').then(m => m.MemberAppointmentsComponent),
          },
          {
            path: 'documents',
            loadComponent: () => import('./pages/members/member-documents/member-documents.component').then(c => c.MemberDocumentsComponent),
          },
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'profile',
          },
        ],
      },
      {
        path: 'members/:id/guarantees/create',
        loadComponent: () => import('./pages/create-medical-service/create-medical-service.component').then(c => c.CreateMedicalServiceComponent),
        resolve: { clientData: clientProfileResolver },
        canDeactivate: [clearMemberProfileGuard],
      },
      {
        path: 'members/:id/prescriptions/:prescriptionId/plannings/:planningId',
        loadComponent: () => import('@lib/members/feature').then(m => m.MemberAppointmentComponent),
        canDeactivate: [clearMemberProfileGuard],
      },
      {
        path: 'chat/threads',
        loadComponent: () => import('@lib/chat/chat.component').then(c => c.ChatComponent),
        children: chatRoutes,
      },
      {
        path: 'connect-chat',
        loadComponent: () => import('./pages/connect-chat/connect-chat.component').then(c => c.ConnectChatComponent),
      },
      {
        path: 'recommendations',
        loadChildren: () => import('@lib/recommendations/feature').then(m => m.recommendationsRoutes),
      },
      {
        path: 'tasks',
        loadChildren: () => import('@lib/tasks').then(m => m.TASKS_ROUTES),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
